import React, { useMemo } from 'react';
import { Box } from '@mui/joy';
import { buildQuizContentHtml } from '../util/quizContentHtml';

export const quizRichTextBaseSx = {
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
    lineHeight: 1.4,
    wordBreak: 'break-word',
    '& .quiz-content-html': {
        width: '100%'
    },
    '& p.quiz-prose': {
        margin: '0 0 0.5em 0',
        lineHeight: 1.4,
        '&:last-child': {
            marginBottom: 0
        }
    },
    '& pre.quiz-code-block': {
        display: 'block',
        width: '100%',
        maxWidth: '100%',
        textAlign: 'left',
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
        overflowWrap: 'anywhere',
        margin: '0.5em 0',
        padding: '12px 14px',
        borderRadius: '8px',
        backgroundColor: '#1e293b',
        border: '1px solid #334155',
        fontFamily: '"Fira Code", "Consolas", "Monaco", monospace',
        fontSize: '0.9em',
        color: '#e2e8f0',
        '& code': {
            fontFamily: 'inherit',
            background: 'transparent',
            padding: 0,
            border: 'none'
        }
    },
    '& code.quiz-inline-code': {
        fontFamily: '"Fira Code", "Consolas", "Monaco", monospace',
        fontSize: '0.88em',
        padding: '2px 6px',
        borderRadius: '4px',
        backgroundColor: 'rgba(30, 41, 59, 0.08)',
        border: '1px solid rgba(51, 65, 85, 0.25)',
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word'
    },
    '& .quiz-syn-kw': {
        color: '#c792ea',
        fontWeight: 700
    },
    '& .quiz-syn-str': {
        color: '#ecc48d'
    },
    '& .quiz-syn-num': {
        color: '#f78c6c'
    },
    '& .quiz-syn-comment': {
        color: '#637777',
        fontStyle: 'italic'
    },
    '& .quiz-syn-pre': {
        color: '#82aaff'
    }
};

/**
 * Renders quiz question/option/explanation with prose, code blocks, and C-like highlighting.
 * @param {{ content?: unknown, sx?: object, className?: string, disablePointerEvents?: boolean }} props
 */
const QuizRichText = ({ content, sx = {}, className = '', disablePointerEvents = false }) => {
    const html = useMemo(() => buildQuizContentHtml(content), [content]);

    if (!html) {
        return null;
    }

    return (
        <Box
            className={`quiz-rich-text ${className}`.trim()}
            sx={[quizRichTextBaseSx, sx]}
        >
            <Box
                sx={disablePointerEvents ? { pointerEvents: 'none' } : undefined}
                dangerouslySetInnerHTML={{ __html: html }}
            />
        </Box>
    );
};

export default QuizRichText;
